import React, { useState } from 'react';
import { ContactView } from './components/ContactView';
export function App() {
  // Mock data for a contact
  const [contact, setContact] = useState({
    id: '1234',
    type: 'person',
    firstName: 'Sarah',
    lastName: 'Johnson',
    email: 'sarah.johnson@example.com',
    phone: '+1 (555) 123-4567',
    company: 'Acme Corporation',
    position: 'Marketing Director',
    dob: '1985-06-15',
    address: {
      street: '123 Business Ave',
      city: 'San Francisco',
      state: 'CA',
      zip: '94107',
      country: 'USA'
    },
    accountBalance: 2450.75,
    tags: ['VIP', 'Marketing', 'Enterprise'],
    assignedTo: 'Michael Scott',
    lastContacted: '2023-09-15T14:30:00',
    created: '2022-03-10T09:15:00',
    notes: [{
      id: 'n1',
      date: '2023-09-15T14:30:00',
      author: 'Michael Scott',
      content: 'Discussed new marketing campaign requirements'
    }, {
      id: 'n2',
      date: '2023-08-22T11:15:00',
      author: 'Jim Halpert',
      content: 'Follow-up call about the proposal. Client is interested but needs time to review with their team.'
    }, {
      id: 'n3',
      date: '2023-07-30T09:45:00',
      author: 'Pam Beesly',
      content: 'Sent updated pricing information as requested'
    }],
    invoices: [{
      id: 'inv-1001',
      date: '2023-09-01',
      amount: 1250.0,
      status: 'paid'
    }, {
      id: 'inv-985',
      date: '2023-08-01',
      amount: 1250.0,
      status: 'paid'
    }, {
      id: 'inv-879',
      date: '2023-07-01',
      amount: 950.75,
      status: 'overdue'
    }],
    communications: [{
      id: 'comm-1',
      date: '2023-09-15T14:30:00',
      type: 'call',
      duration: '15m',
      summary: 'Discussed marketing campaign'
    }, {
      id: 'comm-2',
      date: '2023-09-10T11:15:00',
      type: 'email',
      subject: 'Proposal Follow-up',
      summary: 'Sent additional information'
    }, {
      id: 'comm-3',
      date: '2023-08-28T09:45:00',
      type: 'meeting',
      duration: '1h',
      summary: 'Initial proposal presentation'
    }],
    bookings: [{
      id: 'book-1',
      title: 'Quarterly Review',
      date: '2023-10-15T10:00:00',
      duration: '1h'
    }, {
      id: 'book-2',
      title: 'Contract Renewal Discussion',
      date: '2023-11-05T14:30:00',
      duration: '45m'
    }]
  });
  const handleContactUpdate = updatedContact => {
    setContact(updatedContact);
  };
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-0">
      <ContactView contact={contact} onUpdate={handleContactUpdate} data-id="element-1" />
    </div>;
}